import React from 'react';
import { CandidateAppliedJobsViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: CandidateAppliedJobsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
